export default __webpack_public_path__ + "static/media/happy-holidays.595a0670.webp";